import { AnalyticEvent } from "../AnalyticEvent";
import { EventState } from "../EventState";
import { GA4BaseEvent } from "./GA4BaseEvent";

export class ViewItemEvent extends GA4BaseEvent implements AnalyticEvent {
  payload: EventState;
  name: string;

  constructor(args: EventState) {
    super();
    this.payload = args;
    this.name = "VIEW_ITEM_GA4";
  }

  exec(): void {
    this.fire("view_item", {
      value: this.payload.value || -1,
      currency: this.payload.currency || "IDR",
      items:
        this.payload.items?.map((item) => ({
          item_id: item.id,
          item_name: item.name,
          discount: item.price?.discount,
          item_brand: item.brand,
          item_variant: item.variant,
          price: item.price?.net,
          quantity: item.quantity,
        })) || [],
    });
  }
}
